import React, { useState } from 'react';
import { syncQuoteToEcommerceCart } from '../../Services/quoteSyncToEcommerce';

const ECOMMERCE_CART_URL = 'https://app.rullier.ova-consulting.fr';

/**
 * Bouton pour envoyer les produits du devis vers le panier du site e-commerce.
 * @param {() => Array<{sku: string, qty: number}>} getSyncItems - Fonction qui retourne la liste des items à envoyer (sku, qty)
 * @param {string} [className] - Classes CSS additionnelles pour le bouton
 * @param {string} [label] - Libellé du bouton
 */
const SendQuoteToCartButton = ({ getSyncItems, className = '', label = 'Envoyer le devis au panier du site' }) => {
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState(null);
  const [errors, setErrors] = useState([]);

  const handleClick = async () => {
    const syncItems = typeof getSyncItems === 'function' ? getSyncItems() : [];
    const items = (syncItems || [])
      .map((i) => ({ sku: String(i.sku || '').trim(), qty: Math.max(0, parseInt(i.qty ?? i.quantity, 10) || 0) }))
      .filter((i) => i.sku && i.qty > 0);

    if (!items.length) {
      setStatus('error');
      setMessage('Aucun produit avec SKU valide à envoyer au panier.');
      setErrors([]);
      return;
    }

    setStatus('loading');
    setMessage(null);
    setErrors([]);

    try {
      const result = await syncQuoteToEcommerceCart(items);
      if (result.success) {
        setStatus('success');
        setMessage(
          result.items_added !== undefined
            ? `${result.items_added} produit(s) ajouté(s) au panier.`
            : 'Devis envoyé au panier.'
        );
        if (result.redirect_url) {
          const fullUrl = result.redirect_url.startsWith('http')
            ? result.redirect_url
            : `${ECOMMERCE_CART_URL}${result.redirect_url.startsWith('/') ? '' : '/'}${result.redirect_url}`;
          window.open(fullUrl, '_blank');
        }
      } else {
        setStatus('error');
        setMessage("Erreur lors de l'envoi au panier.");
        setErrors(result.errors || []);
      }
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.message || err.message || 'Impossible de contacter le site e-commerce.');
      setErrors(
        err.response?.data?.errors
          ? Array.isArray(err.response.data.errors)
            ? err.response.data.errors
            : [err.response.data.errors]
          : []
      );
    }
  };

  return (
    <>
      <button
        type="button"
        className={className || 'btn btn-primary mb-3 rounded-0'}
        onClick={handleClick}
        disabled={status === 'loading'}
      >
        {status === 'loading' ? 'Envoi en cours…' : label}
      </button>
      {status === 'success' && message && (
        <div className="alert alert-success small py-2 mb-2">
          {message} Une fenêtre s'est ouverte vers le panier.
        </div>
      )}
      {status === 'error' && (
        <div className="alert alert-danger small py-2 mb-2">
          {message}
          {errors.length > 0 && (
            <ul className="mb-0 mt-1 ps-3">
              {errors.map((e, i) => (
                <li key={i}>{e}</li>
              ))}
            </ul>
          )}
        </div>
      )}
    </>
  );
};

export default SendQuoteToCartButton;
